module.exports = __webpack_public_path__ + "static/the_university_of_alabama-d49c8bcedeebf288e8cf47cde22712b7.png";